'use strict';

var _ = require('lodash');
var DemandCalendarsTransformerFactory = function DemandCalendarsTransformerFactory(DataTransformer, SeasonalityConstants, momentService, UserProcessingTransformationService, configurationService, featureToggleService) {
  function DemandCalendarsTransformerFactory() {
    DataTransformer.call(this);
    this.sourceType = ['seasonality-demand-mode', 'seasonality-show-up-mode', 'seasonality-pooled-mode'];
    this.targetType = ['seasonality-demand-calendars', 'seasonality-pooled-calendars'];
    this.priority = 1;
  }
  DemandCalendarsTransformerFactory.prototype = Object.create(DataTransformer.prototype);
  DemandCalendarsTransformerFactory.constructor = DemandCalendarsTransformerFactory;
  DemandCalendarsTransformerFactory.prototype.canTransform = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) > -1 && this.targetType.indexOf(targetType) > -1;
  };
  DemandCalendarsTransformerFactory.prototype.isCacheable = function () {
    return false;
  };
  DemandCalendarsTransformerFactory.prototype.getCacheKey = function (metrics) {
    return this.sourceType + '-' + this.targetType + '-' + metrics.join('-');
  };
  DemandCalendarsTransformerFactory.prototype.transform = function (data) {
    var results = [];
    for (var i = 0, length = data.domain.results.length; i < length; i++) {
      var entry = data.domain.results[i];
      var newEntry = {
        calendarName: entry.calendarName,
        calendarStatus: entry.calendarStatus,
        createdBy: UserProcessingTransformationService.getUserDisplayName(entry.createdBy),
        createdOn: momentService.of(entry.createdOn, momentService.FIELD.CREATED_AT),
        lastModifiedBy: UserProcessingTransformationService.getUserDisplayName(entry.lastModifiedBy),
        lastModifiedOn: momentService.of(entry.lastModifiedOn, momentService.FIELD.LAST_UPDATED_AT),
        startDepartureDate: momentService.of(entry.startDepartureDate, momentService.FIELD.DEPARTURE_DATE),
        endDepartureDate: momentService.of(entry.endDepartureDate, momentService.FIELD.DEPARTURE_DATE),
        outlierTolerance: entry.outlierTolerance,
        market: entry.market,
        metric: SeasonalityConstants.SEASONALITY_VARIABLE_TO_METRICS[entry.metric],
        profileStatus: entry.profileStatus,
        domainName: entry.domainName,
        level: entry.domainName === 'LegShowUpMetrics' && entry.seasonalityLevel === 'MARKET' ? 'Leg' : SeasonalityConstants.SEASONALITY_LEVEL_TO_LEVEL[entry.seasonalityLevel],
        calendarPublishedStatus: entry.calendarPublishedStatus === SeasonalityConstants.CALENDAR_STATUSES.PUBLISHED || entry.calendarPublishedStatus === SeasonalityConstants.CALENDAR_STATUSES.RUNNING || entry.calendarPublishedStatus === SeasonalityConstants.CALENDAR_STATUSES.ERROR_PROCESSING ? entry.calendarPublishedStatus : '',
        calendarEntryStatus: entry.calendarPublishedStatus,
        saveButtonStatus: entry.saveButtonStatus ? entry.saveButtonStatus : undefined,
        calendarInitDate: entry.calendarInitDate === null ? '' : momentService.of(entry.calendarInitDate, momentService.FIELD.CREATED_AT),
        learningProcess: entry.learningProcess ? _.find(SeasonalityConstants.LEARNING_PROCESSES, {
          id: entry.learningProcess
        }) : undefined,
        regressionTerms: entry.learningProcess ? _.find(SeasonalityConstants.REGRESSION_TERMS, {
          id: entry.regressionTerms
        }) : undefined
      };
      if (featureToggleService.isEnabled('DIRECT_FORECAST_ENABLE')) {
        newEntry.forecastType = configurationService.getMarketForecastType(newEntry.market);
      }
      results.push(newEntry);
    }
    return results;
  };
  return DemandCalendarsTransformerFactory;
};
DemandCalendarsTransformerFactory.$inject = ['DataTransformerFactory', 'SeasonalityConstants', 'MomentService', 'UserProcessingTransformationService', 'ConfigurationService', 'FeatureToggleService'];
module.exports = DemandCalendarsTransformerFactory;